export const educationData = [
  {
    id: 1,
    institution: 'Sir J J Mishra Shala',
    course: 'Higher Secondary Education',
    startYear: '2014',
    endYear: '2017',
  },
  {
    id: 2,
    institution: 'Veer Narmad South Gujarat University',
    course: 'Bachelor of Computer Application',
    startYear: '2017',
    endYear: '2020',
  },
];
